import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { serviceIcon } from "@/lib/icons";
import { Reveal } from "@/components/Reveal";

export const ServiceCard = ({ service, index }) => {
  const Icon = serviceIcon(service.icon);
  return (
    <Reveal delay={(index % 3) * 0.08} className="h-full">
      <Link
        to={`/services#${service.slug}`}
        data-testid={`service-card-${service.slug}`}
        className="group block h-full"
        aria-label={`Learn more about ${service.title}`}
      >
        <div className="relative h-full overflow-hidden rounded-2xl border border-white/10 bg-navy-900 p-8 transition-all duration-300 group-hover:-translate-y-1.5 group-hover:border-gold/60 group-hover:shadow-2xl group-hover:shadow-gold/10">
          <span className="absolute right-6 top-6 font-mono text-xs font-semibold tracking-widest text-gold/40">
            {String(index + 1).padStart(2, "0")}
          </span>
          <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-gold/30 bg-gold/10 text-gold transition-all duration-300 group-hover:bg-gold group-hover:text-navy-950">
            <Icon className="h-6 w-6" />
          </div>
          <h3 className="mt-6 font-serif text-xl font-bold text-white">{service.title}</h3>
          <p className="mt-3 text-sm leading-relaxed text-slate-400">{service.short}</p>
          <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-gold">
            Learn More
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
};
